import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { pbChat } from './adapters/pb-chat'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort } from './domain/chat'

const chat: ChatPort = pbChat
const notify: NotifyPort = notifyAdapter

export { chat, notify }
